import {createApp} from "vue";
import setupSpa from "@/entrypoints/spa/setupSpa";
import router from '@/entrypoints/www/router'
import WwwApp from '@/components/Www.vue'
import hydrateWwwState from '@/entrypoints/www/hydrateWwwState'

const app = createApp(WwwApp)
setupSpa(app, { hasLoggedOutRoutes: true, router, site: 'www', beforeMount: hydrateWwwState });
